import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "warning-span flex align-content-center justify-content-center p-3"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("i", {
    class: "pi pi-exclamation-triangle",
    style: { "color": "var(--purple-500)", "font-size": "2rem", "margin-right": "10px" }
}, null, -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("h5", null, "No website selected", -1);
const _hoisted_4 = [
    _hoisted_2,
    _hoisted_3
];
const _hoisted_5 = { class: "page-container" };
const _hoisted_6 = { class: "grid" };
const _hoisted_7 = { class: "col-12" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", { for: "has_sync_issues_checked" }, "Has synchronization issues", -1);
import InventoryWebsitesTable from "@/components/templates/Inventory/InventoryWebsitesTable.vue";
import { onBeforeMount, ref, watch } from "vue";
import { webSiteColumns } from "@/shared/utils/columns-definition/website";
import { getInventoryWebsitesDataByCriteriaPaginated } from "@/repositories/inventory.repository";
import InventorySearch from "@/components/templates/Inventory/InventorySearch.vue";
import OneDeskCard from "@/components/molecules/OneDeskCard.vue";
import Button from "primevue/button";
import OneDeskMarketColumn from "@/components/molecules/OneDeskMarketColumn.vue";
import Tag from "primevue/tag";
import AppConfigSideBar from "@/components/templates/Layout/AppConfigSideBar.vue";
import UpsertWebSite from "@/components/templates/BackOffice/forms/inventory/UpsertWebSite.vue";
import Checkbox from "primevue/checkbox";
import { useRoute, useRouter } from "vue-router";
import { SearchTarget } from "@/shared/enums/SearchTarget.enum";
export default /*#__PURE__*/ _defineComponent({
    __name: 'BackOfficeInventory',
    setup(__props) {
        const router = useRouter();
        const route = useRoute();
        const pageNumber = ref(1);
        const pageSize = ref(10);
        const searchCriteria = ref({
            searchText: "",
            allWebsitesChecked: false,
            searchTarget: SearchTarget.site,
            brands: [],
            markets: [],
            searchPerimeter: [SearchTarget.site],
            hasSyncIssues: false,
        });
        const columnsDefinition = ref(webSiteColumns);
        const inventory = ref({ items: [], totalCount: 0, pageIndex: 1, totalPages: 0 });
        const selectedWebsiteId = ref(undefined);
        const openAppConfig = ref(false);
        const clearFilters = () => {
            searchCriteria.value = {
                searchText: "",
                allWebsitesChecked: false,
                searchTarget: SearchTarget.site,
                brands: [],
                markets: [],
                searchPerimeter: [SearchTarget.site],
                hasSyncIssues: false,
            };
        };
        const menuItems = [
            {
                label: "Add a website",
                command: () => {
                    router.push({ name: "AddWebSite" });
                },
            },
        ];
        onBeforeMount(async () => {
            const hasSyncIssues = route.query.hasSyncIssues;
            if (hasSyncIssues)
                searchCriteria.value.hasSyncIssues = hasSyncIssues === "true";
            await retrieveInventoryWebsitesPaginated();
        });
        const onWebSiteUpdated = () => {
            selectedWebsiteId.value = undefined;
            openAppConfig.value = false;
            retrieveInventoryWebsitesPaginated();
        };
        watch(searchCriteria, async () => {
            pageNumber.value = 1;
            await retrieveInventoryWebsitesPaginated();
        }, { deep: true });
        watch(pageNumber, async () => {
            await retrieveInventoryWebsitesPaginated();
        });
        const updateSearchText = async (text) => {
            searchCriteria.value.searchText = text;
            pageNumber.value = 1;
            await retrieveInventoryWebsitesPaginated();
        };
        const retrieveInventoryWebsitesPaginated = async () => {
            inventory.value = await getInventoryWebsitesDataByCriteriaPaginated(pageNumber.value, pageSize.value, searchCriteria.value.searchText, searchCriteria.value.brands, searchCriteria.value.markets, searchCriteria.value.allWebsitesChecked, searchCriteria.value.hasSyncIssues);
        };
        const onEditClick = (id) => {
            selectedWebsiteId.value = id;
            openAppConfig.value = true;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(AppConfigSideBar, {
                    simple: "",
                    title: "Manage websites",
                    active: selectedWebsiteId.value !== undefined,
                    modelValue: openAppConfig.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((openAppConfig).value = $event))
                }, {
                    default: _withCtx(() => [
                        (selectedWebsiteId.value)
                            ? (_openBlock(), _createBlock(UpsertWebSite, {
                                key: 0,
                                webSiteId: selectedWebsiteId.value,
                                onWebsiteUpdated: onWebSiteUpdated
                            }, null, 8, ["webSiteId"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
                    ]),
                    _: 1
                }, 8, ["active", "modelValue"]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(OneDeskCard, {
                                title: "Websites",
                                "has-search": true,
                                "has-menu": true,
                                "menu-items": menuItems,
                                "onUpdate:searchText": _cache[4] || (_cache[4] = ($event) => (updateSearchText($event))),
                                onClearFilters: clearFilters
                            }, {
                                filters: _withCtx(() => [
                                    _createVNode(InventorySearch, {
                                        modelValue: searchCriteria.value,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((searchCriteria).value = $event))
                                    }, {
                                        actions: _withCtx(() => [
                                            _createVNode(_unref(Checkbox), {
                                                modelValue: searchCriteria.value.hasSyncIssues,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((searchCriteria.value.hasSyncIssues) = $event)),
                                                inputId: "has_sync_issues_checked",
                                                name: "allWebsitesChecked",
                                                binary: ""
                                            }, null, 8, ["modelValue"]),
                                            _hoisted_8
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue"])
                                ]),
                                content: _withCtx(() => [
                                    _createVNode(InventoryWebsitesTable, {
                                        "table-data": inventory.value.items,
                                        "columns-definition": columnsDefinition.value,
                                        "data-test": "inventory-sub-table",
                                        "has-pagination": true,
                                        "header-class": "website-table-header",
                                        "row-class": "rowClass",
                                        totalRecords: inventory.value.totalCount,
                                        "page-index": pageNumber.value,
                                        "page-size": pageSize.value,
                                        onPageChange: _cache[3] || (_cache[3] = ($event) => (pageNumber.value = $event + 1)),
                                        "on-row-click": ($event) => onEditClick($event.id)
                                    }, {
                                        updated: _withCtx((slotProps) => [
                                            _createElementVNode("span", null, _toDisplayString(new Date(slotProps.item.updated).toLocaleString()), 1)
                                        ]),
                                        isPublic: _withCtx((slotProps) => [
                                            _createVNode(_unref(Tag), {
                                                icon: slotProps.item.isPublic ? 'pi pi-lock-open' : 'pi pi-lock',
                                                value: slotProps.item.isPublic ? 'Public' : 'Private',
                                                severity: slotProps.item.isPublic ? 'success' : 'warning'
                                            }, null, 8, ["icon", "value", "severity"])
                                        ]),
                                        displayMarket: _withCtx((slotProps) => [
                                            _createVNode(OneDeskMarketColumn, {
                                                "market-code": slotProps.item.displayMarket
                                            }, null, 8, ["market-code"])
                                        ]),
                                        actions: _withCtx((slotProps) => [
                                            _createVNode(_unref(Button), {
                                                icon: "pi pi-pencil",
                                                severity: "primary",
                                                onClick: ($event) => (onEditClick(slotProps.item.id))
                                            }, null, 8, ["onClick"])
                                        ]),
                                        _: 1
                                    }, 8, ["table-data", "columns-definition", "totalRecords", "page-index", "page-size", "on-row-click"])
                                ]),
                                _: 1
                            })
                        ])
                    ])
                ])
            ], 64));
        };
    }
});
